export default __webpack_public_path__ + "static/media/mariam.b30aa534.png";